import type { LineStatus, Order } from './types';

export type Lane = 'new' | 'cooking' | 'ready';
const ACTIVE: LineStatus[] = ['queued', 'cooking', 'ready'];

/** Where a ticket sits on the board: the earliest stage any of its dishes is still in. */
export function laneOf(o: Order): Lane | null {
  const st = o.lines.map((l) => l.status);
  if (st.includes('queued')) return 'new';
  if (st.includes('cooking')) return 'cooking';
  if (st.includes('ready')) return 'ready';
  return null; // all served / cancelled: off the board
}

/** The button on a ticket moves every dish that is still behind to the next stage. */
export function advance(o: Order): { status: LineStatus; lineIds: string[] } | null {
  const lane = laneOf(o);
  if (!lane) return null;
  const from: Record<Lane, LineStatus[]> = { new: ['queued'], cooking: ['queued', 'cooking'], ready: ['ready'] };
  const to: Record<Lane, LineStatus> = { new: 'cooking', cooking: 'ready', ready: 'served' };
  return { status: to[lane], lineIds: o.lines.filter((l) => from[lane].includes(l.status)).map((l) => l.id) };
}

export const isActive = (o: Order) => o.lines.some((l) => ACTIVE.includes(l.status));
export const minutesSince = (iso: string, now: number) => Math.max(0, Math.floor((now - Date.parse(iso)) / 60_000));
export const LATE_MINUTES = 15;
